/**
 * Builds the singleton CoreAPI for the running app from validated env.
 * `createCoreAPI` (in @praesto/core) owns Firebase init + emulator wiring;
 * the web only supplies config + the tenant slug.
 *
 * The React context (CoreProvider/useCore) lives in @praesto/core so feature
 * modules can consume `core` without importing the host app — re-exported
 * here for ergonomic web-side imports.
 */
import type { CoreAPI } from "@praesto/contracts";
import { createCoreAPI } from "@praesto/core";
import { getEnv } from "./env";

export { CoreProvider, useCore, ActiveHotelProvider, useActiveHotel } from "@praesto/core";

let instance: CoreAPI | null = null;

export function getCore(tenantSlug: string): CoreAPI {
  if (instance) return instance;
  const env = getEnv();
  instance = createCoreAPI({
    tenantSlug,
    firebaseConfig: {
      apiKey: env.firebase.apiKey,
      authDomain: env.firebase.authDomain,
      projectId: env.firebase.projectId,
      appId: env.firebase.appId,
      storageBucket: env.firebase.storageBucket,
      messagingSenderId: env.firebase.messagingSenderId,
    },
    ...(env.useEmulators
      ? {
          emulators: {
            auth: env.emulators.auth,
            firestore: env.emulators.firestore,
            storage: env.emulators.storage,
          },
        }
      : {}),
  });
  return instance;
}
